import Clipboard from "@react-native-clipboard/clipboard";
import { capitalCase } from "change-case";
import React from "react";
import { View, Text } from "react-native";

import { sendRequest } from "../ApiUtil";

import {
  getIsBridgeActiveFromCookies,
  setBridgeStatusInCookies,
} from "@/utils/cookies/Cookies";

type Customer = "CORPORATION" | "INDIVIDUAL";

export interface DepositInstructions {
  applicationId?: string;
  bankBeneficiaryName: string;
  bankRoutingNumber: string;
  bankAccountNumber: string;
  bankBeneficiaryAddress: string;
  bankName: string;
  bankAddress: string;
  customerId?: string;
}

export interface CustomerData {
  customerType?: Customer;
  type: "business" | "individual";
  address?: {
    addressLine1: string;
    city: string;
    state: string;
    countryCode: string;
    postalCode: string;
  };
}

const formatAddress = (address: string) => {
  const addressSplitted = address.split(",");
  const splitStateAndZipCode = addressSplitted[2].trim().split(" ");

  const data = {
    addressLine1: addressSplitted[0].trim(),
    city: addressSplitted[1].trim(),
    state: splitStateAndZipCode[0].trim(),
    countryCode: addressSplitted[3]?.trim() || "US",
    postalCode: splitStateAndZipCode[1].trim(),
  };

  return data;
};

export const convertDepositInstructionsToCounterpartyFormat = (
  depositInstructions: DepositInstructions,
  customerData: CustomerData
) => {
  const bankAddress = formatAddress(depositInstructions.bankAddress);
  const beneficiaryAddress = formatAddress(
    depositInstructions.bankBeneficiaryAddress
  );
  const customerType = {
    business: "CORPORATION",
    individual: "INDIVIDUAL",
  };
  return {
    counterpartyType: "FIAT_US",
    rails: ["ACH", "FEDWIRE"],
    profile: {
      profileType: customerType[customerData.type],
      name: depositInstructions.bankBeneficiaryName,
      relationshipToCustomer: "SELF",
      address: beneficiaryAddress,
    },
    accountInformation: {
      type: "CHECKING",
      accountNumber: depositInstructions.bankAccountNumber,
      routingNumber: depositInstructions.bankRoutingNumber,
      institutionName: depositInstructions.bankName,
      institutionAddress: bankAddress,
    },
  };
};

export const renderDepositInstructions = (
  data: any,
  t: any,
  keysToIgnore: string[]
) => {
  return Object.entries(data)
    .filter(([key]) => !keysToIgnore.includes(key))
    .map(([key, value]) => (
      <View className="flex-row my-0.5 w-full justify-between" key={key}>
        <Text
          numberOfLines={1}
          ellipsizeMode="tail"
          className="text-sm font-light max-w-56"
        >
          {t(`home/modals/cryptodeposit:deposit.${key}`)}:
        </Text>
        <Text
          numberOfLines={1}
          ellipsizeMode="tail"
          className="text-sm max-w-56"
        >
          {String(value)}
        </Text>
      </View>
    ));
};

export const copyToClipboard = (object: any) => {
  return Clipboard.setString(
    Object.entries(object)
      .map(([key, value]) => `${capitalCase(key)}: ${value}`)
      .join("\n")
  );
};

export async function getBridgeStatus() {
  try {
    const request = await sendRequest("get", "/bridge/customer", null, true);
    if (request && request.status) {
      setBridgeStatusInCookies(request.status.toUpperCase());
    } else {
      setBridgeStatusInCookies("PENDING");
    }
  } catch (error: any) {
    console.log(error);
    setBridgeStatusInCookies("PENDING");
  }
}

export function checkIsBridgeApproved() {
  const isBridgeActive = getIsBridgeActiveFromCookies();
  if (isBridgeActive === "ACTIVE") {
    return true;
  }
  return false;
}
